import React from "react";

interface CarouselDotsProps {
    totalSlides: number;
    currentSlide: number;
    onSlideChange: (index: number) => void;
    className?: string;
    ariaLabelPrefix?: string;
}

export const CarouselDots: React.FC<CarouselDotsProps> = ({
    totalSlides,
    currentSlide,
    onSlideChange,
    className = "",
    ariaLabelPrefix = "Go to slide",
}) => {
    return (
        <div className={`flex justify-center gap-1 ${className}`}>
            {Array.from({ length: totalSlides }).map((_, index) => (
                <button
                    key={index}
                    onClick={() => onSlideChange(index)}
                    className={`group p-2 rounded-full transition-all duration-300 cursor-pointer flex items-center justify-center ${
                        index === currentSlide ? "scale-110" : "hover:bg-gray-100 active:scale-95"
                    }`}
                    aria-label={`${ariaLabelPrefix} ${index + 1}`}
                >
                    <div
                        className={`rounded-full transition-all duration-300 ease-out ${
                            index === currentSlide
                                ? "bg-primary w-6 h-2 shadow-md shadow-primary/30"
                                : "bg-gray-300 group-hover:bg-primary/60 group-hover:scale-125 w-2 h-2"
                        }`}
                    />
                </button>
            ))}
        </div>
    );
};
